import { includes } from 'lodash';

export const isExcluded = (pathname: string) => {
  const excludedPaths = [
    '/login',
    '/check-out',
    '/forgot-password',
    '/reset-password/[token]',
    '/reset-success',
  ];
  const isExcluded = excludedPaths.map((path) => {
    return includes(pathname, path);
  });
  return isExcluded.some((excluded) => excluded);
};
